import { render } from "./footer-paragraphs-list.vue?vue&type=template&id=3d020f10"
import script from "./footer-paragraphs-list.vue?vue&type=script&lang=js"
export * from "./footer-paragraphs-list.vue?vue&type=script&lang=js"

import "./footer-paragraphs-list.vue?vue&type=style&index=0&id=3d020f10&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__